import type { MouseEventHandler, ReactNode } from 'react';

import clsx from 'clsx';

import { container, containerDivider, segment, segmentItem, toggleButton } from './styles.css';

export interface ScheduleToolbarProps {
  children: ReactNode;
  divider?: boolean;
}

export const ScheduleToolbar = (props: ScheduleToolbarProps) => {
  const { children, divider } = props;

  return (
    <div
      className={clsx(container, {
        [containerDivider]: divider,
      })}
    >
      {children}
    </div>
  );
};

export interface ScheduleToolbarToggleProps {
  children: ReactNode;
  icon: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

ScheduleToolbar.Toggle = (props: ScheduleToolbarToggleProps) => {
  const { children, icon, onClick } = props;

  return (
    <button className={toggleButton} onClick={onClick}>
      {icon}
      <span>{children}</span>
    </button>
  );
};

export interface ScheduleToolbarSegmentProps {
  value?: string;
  options: { icon: ReactNode; value: string; label: ReactNode }[];
  onChange?: (value: string) => void;
}

ScheduleToolbar.Segment = (props: ScheduleToolbarSegmentProps) => {
  const { value, options, onChange } = props;

  return (
    <div className={segment}>
      {options.map((option) => {
        const active = value === option.value;
        return (
          <button
            key={option.value}
            className={segmentItem({
              active,
            })}
            onClick={() => onChange?.(option.value)}
          >
            {option.icon}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};
